import createOfferingPaymentModule from '@/store/modules/offeringPaymentModule';
import { PAYMENT_FLOWS } from '@/pages/responsive-pages/non-authenticated/offering-payment/paymentFlows';

export const leadPayment = createOfferingPaymentModule({
  offeringIds: PAYMENT_FLOWS.specialClub.offeringIds,
  flow: PAYMENT_FLOWS.specialClub.flow,
});

export const advisoryPayment = createOfferingPaymentModule({
  offeringIds: PAYMENT_FLOWS.advisory.offeringIds,
  flow: PAYMENT_FLOWS.advisory.flow,
});

export const oneOffPayment = createOfferingPaymentModule({
  offeringIds: PAYMENT_FLOWS.oneOff.offeringIds,
  flow: PAYMENT_FLOWS.oneOff.flow,
});
